import React from 'react'
import {FlyersMarketplace} from "../components/marketing/FlyersMarketplace";

export const FlyersMarketplacePage = () => {
    return (
        <FlyersMarketplace/>
    )
}
